import moment from 'moment';
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { getLoanVehicleUsage, LoanVehicleRegListByBranch, LoanVehicleSearch, postLoanVehicleUsage } from '../../../Core/Service/loanVehicleUsage-service';
import AppContext from '../../../App/AppContext';
import { Header } from './../../../Core/Header/index';

export const LoanVehicleContext = createContext();

export const LoanVehicleProvider = (props) => {
    const urlParams = new URLSearchParams(props.location?.search?.toLowerCase());

    const [state, setState] = useState({
        handOverCustomerSignature: '',
        handoverCustomerSignatureOut: '',
        handoverStaffSignatureOut: '',
        handoverCustomerSignatureIn: '',
        handoverStaffSignatureIn: '',
        loading: true,
        loanVehicleList: [],
        isVehicleInState: false,
        isUpdate: false,
        isVehicleReceived: false,
        customerSignatureOutSignUser: '',
        termsAndCondition: '',
        tempTermsAndCondition: ''
    });
    const [companyDetails, setCompanyDetails] = useState({
        companyContactName: '',
        companyContactEmail: '',
        companyContactCompany: '',
        companyContactNumber: '',
        companyContactAddress: '',
        companyContactPostCode: '',
        companyContactReasonForUse: '',
        companyDriverName: '',
        companyRegistrationNumber: '',
        companyWIPNumber: null
    });

    const [loading, setLoading] = useState(false);

    const { showToast } = useContext(AppContext);

    const [insuranceDetails, setInsuranceDetails] = useState({
        insuranceCompanyName: '',
        insuranceCompanyAddress: '',
        insuranceCompanyPolicyNumber: '',
        insurancePolicyStartDate: null,
        insurancePolicyRenewalDate: null
    });

    const [bookingDetails, setBookingDetails] = useState({
        dateOut: null,
        dateIn: null,
        estimatedDateDueIn: null,
        mileageOut: null,
        mileageIn: null,
        fuelOut: null,
        fuelIn: null
    });

    const [handOverDetails, setHandOverDetails] = useState({
        handOverCustomerSignature: '',
        handedOverName: '',
        handoverCustomerSignatureOut: '',
        handoverStaffSignatureOut: '',
        handoverCustomerSignatureIn: '',
        handoverStaffSignatureIn: ''
    });

    console.log(handOverDetails, 'handOverDetails');

    const [loanVehicleInImages, setLoanVehicleInImages] = useState([]);
    const [loanVehicleOutImages, setLoanVehicleOutImages] = useState([]);

    const [vehicleDetails, setVehicleDetails] = useState({
        dateCreated: moment().format('YYYY-MM-DD'),
        vehicleModel: '',
        insuranceValue: null,
        loanVehicleList: [],
        vehicleReg: ''
    });

    const [searchVehicleList, setSearchVehicleList] = useState([]);

    console.log(vehicleDetails, 'vehicleDetails');

    const [errors, setErrors] = useState({});

    const handleVehicleDetails = (e) => {
        const { name, value } = e.target;
        if (name === 'loanVehicleID') {
            getRegNubmer(value);
        }
        setVehicleDetails((vehicleDetails) => ({ ...vehicleDetails, [name]: value }));
        setState((prev) => ({ ...prev, isUpdate: true }));
    };

    const handleCompanyContactDetails = (e) => {
        const { name, value } = e.target;
        setCompanyDetails({ ...companyDetails, [name]: value });
    };

    const handleInsuranceDetails = (e) => {
        const { name, value } = e.target;
        setInsuranceDetails({ ...insuranceDetails, [name]: value });
    };

    const handleBookingDetails = (e) => {
        const { name, value } = e.target;
        setBookingDetails({ ...bookingDetails, [name]: value });
        validateMileage(name, value);
    };
    const handleHandOverDetails = (e) => {
        const { name, value } = e.target;
        setHandOverDetails({ ...handOverDetails, [name]: value });
    };

    const fieldChange = (val) => {
        setHandOverDetails((st) => ({
            ...st,
            ...val
        }));
    };

    const clearSig = (val) => {
        setState((st) => ({
            ...st,
            partApproverSignature: null
        }));
    };

    useEffect(() => {
        if (props.BranchID && props.tCardID) {
            const searchLoanVehicle = async () => {
                let res = await LoanVehicleRegListByBranch(props.BranchID, props.tCardID);
                if (res.success) {
                    let data = res?.data?.list || [];
                    setSearchVehicleList(data.map((k) => ({ ...k, id: k.loanVehicleID, name: k.regNo })) || []);
                }
            };
            return searchLoanVehicle();
        }
    }, [props.BranchID, props.tCardID]);

    const getRegNubmer = (id) => {
        if (!id) {
            return;
        } else {
            let obj = searchVehicleList.find((k) => k.id === id);

            console.log(obj, 'obj');

            setVehicleDetails((prev) => ({
                ...prev,
                vehicleReg: obj.regNo,
                vehicleModel: obj.vehicleModel
            }));
        }
    };

    let fetchData = async () => {
        try {
            if (props.tCardID) {
                setState((prev) => ({ ...prev, loading: true }));
                let res = await getLoanVehicleUsage(props.tCardID);

                if (res.success) {
                    let data = res?.data?.detail[0] || {};
                    setCompanyDetails({
                        companyContactName: data.companyContactName,
                        companyContactEmail: data.companyContactEmail,
                        companyContactCompany: data.companyContactCompany,
                        companyContactNumber: data.companyContactNumber,
                        companyContactAddress: data.companyContactAddress,
                        companyContactPostCode: data.companyContactPostCode,
                        companyContactReasonForUse: data.companyContactReasonForUse,
                        companyDriverName: data.companyDriverName,
                        companyRegistrationNumber: data.companyRegistrationNumber,
                        companyWIPNumber: data.companyWIPNumber
                    });

                    // Update Insurance Details
                    setInsuranceDetails({
                        insuranceCompanyName: data.insuranceCompanyName,
                        insuranceCompanyAddress: data.insuranceCompanyAddress,
                        insuranceCompanyPolicyNumber: data.insuranceCompanyPolicyNumber,
                        insurancePolicyStartDate: data.insurancePolicyStartDate ? moment(data.insurancePolicyStartDate).format('YYYY-MM-DD') : '',
                        insurancePolicyRenewalDate: data.insurancePolicyRenewalDate ? moment(data.insurancePolicyRenewalDate).format('YYYY-MM-DD') : ''
                    });

                    // Update Vehicle Details
                    setVehicleDetails({
                        vehicleModel: data.vehicleModel,
                        insuranceValue: data.insuranceValue,
                        vehicleReg: data.registrationNumber,
                        loanVehicleID: data.loanVehicleID,
                        dateCreated: data.dateCreated ? moment(data.dateCreated).format('YYYY-MM-DD') : '',
                        loanVehicleUsageID: data.loanVehicleUsageID
                    });

                    // Update Booking Details
                    setBookingDetails({
                        dateOut: data.dateOut ? moment(data.dateOut).format('YYYY-MM-DDTHH:mm') : '',
                        dateIn: data.dateIn ? moment(data.dateIn).format('YYYY-MM-DDTHH:mm') : '',
                        estimatedDateDueIn: data.estimatedDateDueIn ? moment(data.estimatedDateDueIn).format('YYYY-MM-DDTHH:mm') : '',
                        mileageOut: data.mileageOut,
                        mileageIn: data.mileageIn,
                        fuelOut: data.fuelOut,
                        fuelIn: data.fuelIn
                    });

                    // Update Handover Details
                    setHandOverDetails({
                        handedOverName: data.handedOverName,
                        handOverCustomerSignature: data.handOverCustomerSignature,
                        handoverCustomerSignatureOut: data.handoverCustomerSignatureOut,
                        handoverStaffSignatureOut: data.handoverStaffSignatureOut,
                        handoverCustomerSignatureIn: data.handoverCustomerReturnSignature,
                        handoverStaffSignatureIn: data.handoverStaffReturnSignature
                    });

                    setLoanVehicleOutImages(res?.data?.loanVehicleOutImages ? res?.data?.loanVehicleOutImages?.map((image) => image.outVehicleImage) : []);
                    setLoanVehicleInImages(res?.data?.loanVehicleInImages ? res?.data?.loanVehicleInImages.map((image) => image.inVehicleImage) : []);
                    setState((prev) => ({
                        ...prev,
                        handOverCustomerSignature: data.handOverCustomerSignature,
                        handoverCustomerSignatureOut: data.handoverCustomerSignatureOut,
                        handoverStaffSignatureOut: data.handoverStaffSignatureOut,
                        handoverCustomerSignatureIn: data.handoverCustomerReturnSignature,
                        handoverStaffSignatureIn: data.handoverStaffReturnSignature,
                        loading: false,
                        isVehicleInState: data.handoverCustomerSignatureOut ? true : false,
                        isVehicleReceived: data.handoverCustomerReturnSignature ? true : false,
                        customerSignatureOutSignUser: data.customerSignatureOutSignUser,
                        customerSignatureOutSignDate: data.customerSignatureOutSignDate,
                        customerReturnSignatureSignDate: data.customerReturnSignatureSignDate,
                        customerReturnSignatureSignUser: data.customerReturnSignatureSignUser,
                        isReadonly: data.handoverCustomerSignatureOut,
                        termsAndCondition: data.termsAndCondition
                    }));
                } else {
                    setState((prev) => ({
                        ...prev,
                        error: 'Failed to fetch loan vehicle data',
                        loading: false,
                        isVehicleInState: false,
                        isVehicleReceived: false
                    }));
                }
            }
        } catch (error) {
            console.error('Error fetching loan vehicle data:', error);
            setState((prev) => ({
                ...prev,
                loading: false
            }));
        }
    };

    useEffect(() => {
        fetchData();
    }, [props.tCardID]);

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleInImageUpload = async (event) => {
        const files = Array.from(event.target.files);

        // Convert files to base64
        const newImages = await Promise.all(
            files.map(async (file) => {
                const base64 = await convertToBase64(file);
                return {
                    file,
                    preview: URL.createObjectURL(file),
                    base64: base64
                };
            })
        );

        setLoanVehicleInImages((prev) => [...prev, ...newImages]);
    };

    const handleInRemoveImage = (indexToRemove) => {
        setLoanVehicleInImages((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const handleOutImageUpload = async (event) => {
        const files = Array.from(event.target.files);

        const newImages = await Promise.all(
            files.map(async (file) => {
                const base64 = await convertToBase64(file);
                return {
                    file,
                    preview: URL.createObjectURL(file),
                    base64: base64
                };
            })
        );

        setLoanVehicleOutImages((prev) => [...prev, ...newImages]);
    };

    const handleOutRemoveImage = (indexToRemove) => {
        setLoanVehicleOutImages((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const validateMileage = (name, value) => {
        if (name === 'mileageIn' && value !== '') {
            const mileageOut = Number(bookingDetails.mileageOut);
            const mileageIn = Number(value);

            if (mileageIn < mileageOut) {
                setErrors((prev) => ({
                    ...prev,
                    mileageIn: 'Mileage In must be greater than Mileage Out'
                }));
            } else {
                setErrors((prev) => ({
                    ...prev,
                    mileageIn: null
                }));
            }
        }
    };

    const validateForm = () => {
        let errors = {};
        let isValid = true;

        if (!vehicleDetails.vehicleModel) {
            errors.vehicleModel = 'Vehicle Model is required';
            isValid = false;
        }
        if (!vehicleDetails.dateCreated) {
            errors.dateCreated = 'Date is required';
            isValid = false;
        }
        if (!companyDetails.companyDriverName) {
            errors.companyDriverName = 'Driver Name is required';
            isValid = false;
        }
        if (!companyDetails.companyContactAddress) {
            errors.companyContactAddress = 'Location is required';
            isValid = false;
        }
        if (!bookingDetails.dateOut) {
            errors.dateOut = 'Date Out is required';
            isValid = false;
        }
        if (!handOverDetails.handoverCustomerSignatureOut) {
            errors.handoverStaffSignatureOut = 'Signature is required';
            isValid = false;
        }
        if (state.handoverCustomerSignatureOut) {
            if (!bookingDetails.dateIn) {
                errors.dateIn = 'Date In is required';
                isValid = false;
            }
            if (!handOverDetails.handoverCustomerSignatureIn) {
                errors.handoverCustomerSignatureIn = 'Signature is required';
                isValid = false;
            }
        }

        setErrors(errors);
        return isValid;
    };
    console.log(errors, 'errors');
    console.log(state, 'state');

    const validateVehicleIn = () => {
        let errors = {};
        let isValid = true;

        if (!bookingDetails.dateIn) {
            errors.dateIn = 'Date is required';
            isValid = false;
        }
        if (!bookingDetails.dateIn) {
            errors.dateIn = 'Date is required';
            isValid = false;
        }

        setErrors(errors);
        return isValid;
    };

    const handleSave = async () => {
        if (validateForm()) {
            handleSubmit();
        }
    };

    const parseErrors = (errorObj) => {
        const errorMessages = [];
        if (errorObj.errors) {
            Object.entries(errorObj.errors).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((errorMsg) => errorMessages.push(`${key}: ${errorMsg}`));
                } else {
                    errorMessages.push(`${key}: ${value}`);
                }
            });
        } else {
            errorMessages.push('An unknown error occurred.');
        }
        return errorMessages;
    };

    const handleSubmit = async (isAutoSave = false) => {
        try {
            const currentState = isAutoSave ? stateRef.current : state;
            const currentCompanyDetailsRef = isAutoSave ? companyDetailsRef.current : companyDetails;
            const currentInsuranceDetailsRef = isAutoSave ? insuranceDetailsRef.current : insuranceDetails;
            const currentBookingDetailsRef = isAutoSave ? bookingDetailsRef.current : bookingDetails;
            const currentHandOverDetailsRef = isAutoSave ? handOverDetailsRef.current : handOverDetails;
            const currentVehicleDetailsRef = isAutoSave ? vehicleDetailsRef.current : vehicleDetails;
            const currentLoanVehicleInImagesRef = isAutoSave ? loanVehicleInImagesRef.current : loanVehicleInImages;
            const currentLoanVehicleOutImagesRef = isAutoSave ? loanVehicleOutImagesRef.current : loanVehicleOutImages;

            // if (validateForm()) {
            setLoading(true);
            const payload = {
                tCardID: props.tCardID,
                dateCreated: currentVehicleDetailsRef.dateCreated ? moment(currentVehicleDetailsRef.dateCreated).format('YYYY-MM-DD') : '',
                loanVehicleID: currentVehicleDetailsRef.loanVehicleID,
                loanVehicleUsageID: currentVehicleDetailsRef.loanVehicleUsageID,

                registrationNumber: currentVehicleDetailsRef.vehicleReg,
                insuranceValue: currentVehicleDetailsRef.insuranceValue,
                dateOut: currentBookingDetailsRef.dateOut ? moment(currentBookingDetailsRef.dateOut).format('YYYY-MM-DDTHH:mm') : '',
                companyContactName: currentCompanyDetailsRef.companyContactName,
                companyContactEmail: currentCompanyDetailsRef.companyContactEmail,
                companyContactCompany: currentCompanyDetailsRef.companyContactCompany,
                companyContactNumber: currentCompanyDetailsRef.companyContactNumber,
                companyContactAddress: currentCompanyDetailsRef.companyContactAddress,
                companyContactPostCode: currentCompanyDetailsRef.companyContactPostCode,
                companyContactReasonForUse: currentCompanyDetailsRef.companyContactReasonForUse,
                companyDriverName: currentCompanyDetailsRef.companyDriverName,
                companyRegistrationNumber: currentCompanyDetailsRef.companyRegistrationNumber,
                companyWIPNumber: currentCompanyDetailsRef.companyWIPNumber,
                insuranceCompanyName: currentInsuranceDetailsRef.insuranceCompanyName,
                insuranceCompanyAddress: currentInsuranceDetailsRef.insuranceCompanyAddress,
                insuranceCompanyPolicyNumber: currentInsuranceDetailsRef.insuranceCompanyPolicyNumber,
                insurancePolicyStartDate: currentInsuranceDetailsRef.insurancePolicyStartDate
                    ? moment(currentInsuranceDetailsRef.insurancePolicyStartDate).format('YYYY-MM-DD')
                    : '',
                insurancePolicyRenewalDate: currentInsuranceDetailsRef.insurancePolicyRenewalDate
                    ? moment(currentInsuranceDetailsRef.insurancePolicyRenewalDate).format('YYYY-MM-DD')
                    : '',
                vehicleModel: vehicleDetails.vehicleModel,
                dateIn: currentBookingDetailsRef.dateIn ? moment(currentBookingDetailsRef.dateIn).format('YYYY-MM-DDTHH:mm') : '',
                mileageOut: currentBookingDetailsRef.mileageOut,
                mileageIn: currentBookingDetailsRef.mileageIn,
                fuelOut: currentBookingDetailsRef.fuelOut,
                fuelIn: currentBookingDetailsRef.fuelIn,
                estimatedDateDueIn: currentBookingDetailsRef.estimatedDateDueIn,
                handOverCustomerSignature: currentHandOverDetailsRef.handOverCustomerSignature,
                handedOverName: currentHandOverDetailsRef.handedOverName,
                handoverCustomerSignatureOut: currentHandOverDetailsRef.handoverCustomerSignatureOut,
                handoverStaffSignatureOut: currentHandOverDetailsRef.handoverStaffSignatureOut,
                handoverCustomerReturnSignature: currentHandOverDetailsRef.handoverCustomerSignatureIn,
                handoverStaffReturnSignature: currentHandOverDetailsRef.handoverStaffSignatureIn,
                loanVehicleInImages: currentLoanVehicleInImagesRef.filter((image) => image.base64).map((image) => image.base64),
                loanVehicleOutImages: currentLoanVehicleOutImagesRef.filter((image) => image.base64).map((image) => image.base64),
                termsAndCondition: state.tempTermsAndCondition
            };

            const response = await postLoanVehicleUsage(payload);
            if (response.success) {
                showToast(response.message);
                if (!isAutoSave) {
                    props.onClose && props.onClose(true);
                }
                setLoading(false);
            } else {
                const errorMessages = parseErrors(response);
                errorMessages.map((msg, index) => showToast(msg));

                setLoading(false);
            }
            // }
            // return response;
        } catch (error) {
            showToast('Error submitting loan vehicle form');
            setLoading(false);
            throw error;
        }
    };

    const handleTermsAndCondition = (e) => {
        setState((st) => ({
            ...st,
            isTermsAndCondition: e.target.checked,
            tempTermsAndCondition: e.target.checked ? state.termsAndCondition : true,
            showTermAndCond: false
        }));
    };
    const setTermsAndConditions = (flag) => {
        setState((st) => ({
            ...st,
            isTermsAndCondition: flag,
            tempTermsAndCondition: flag ? state.termsAndCondition : true,
            showTermAndCond: false
        }));
    };

    const SetShowTermAndCond = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setState((st) => ({
            ...st,
            showTermAndCond: true
        }));
    };

    const closeWarningModal = (res) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.showTermAndCond = false;
            return newSt;
        });
    };

    const stateRef = useRef(state);
    const companyDetailsRef = useRef(companyDetails);
    const insuranceDetailsRef = useRef(insuranceDetails);
    const bookingDetailsRef = useRef(bookingDetails);
    const handOverDetailsRef = useRef(handOverDetails);
    const vehicleDetailsRef = useRef(vehicleDetails);
    const loanVehicleInImagesRef = useRef(loanVehicleInImages);
    const loanVehicleOutImagesRef = useRef(loanVehicleOutImages);

    // Keep refs updated
    useEffect(() => {
        stateRef.current = state;
    }, [state]);
    useEffect(() => {
        companyDetailsRef.current = companyDetails;
    }, [companyDetails]);
    useEffect(() => {
        insuranceDetailsRef.current = insuranceDetails;
    }, [insuranceDetails]);
    useEffect(() => {
        bookingDetailsRef.current = bookingDetails;
    }, [bookingDetails]);
    useEffect(() => {
        handOverDetailsRef.current = handOverDetails;
    }, [handOverDetails]);
    useEffect(() => {
        vehicleDetailsRef.current = vehicleDetails;
    }, [vehicleDetails]);
    useEffect(() => {
        loanVehicleInImagesRef.current = loanVehicleInImages;
    }, [loanVehicleInImages]);
    useEffect(() => {
        loanVehicleOutImagesRef.current = loanVehicleOutImages;
    }, [loanVehicleOutImages]);

    // Inside LoanVehicleProvider component
    // useEffect(() => {
    //     if (props.tCardID) {
    //         let timeoutId = null;

    //         const triggerAutoSave = () => {
    //             clearTimeout(timeoutId);
    //             timeoutId = setTimeout(() => {
    //                 handleSubmit(true); // Your existing save function
    //             }, 10000); // 10 seconds after last interaction
    //         };

    //         // Listen for user activity
    //         const events = [
    //             'keydown',
    //             'mousedown',
    //             // 'mousemove',
    //             'touchstart'
    //         ];
    //         events.forEach((event) => window.addEventListener(event, triggerAutoSave));

    //         return () => {
    //             events.forEach((event) => window.removeEventListener(event, triggerAutoSave));
    //             clearTimeout(timeoutId);
    //         };
    //     }
    // }, []);

    return (
        <LoanVehicleContext.Provider
            value={{
                companyDetails,
                handleCompanyContactDetails,
                insuranceDetails,
                handleInsuranceDetails,
                bookingDetails,
                handleBookingDetails,
                handOverDetails,
                fieldChange,
                clearSig,
                state,
                handleHandOverDetails,
                vehicleDetails,
                handleVehicleDetails,
                handleInImageUpload,
                handleInRemoveImage,
                loanVehicleInImages,
                loanVehicleOutImages,
                handleOutImageUpload,
                handleOutRemoveImage,
                handleSubmit,
                // searchLoanVehicle,
                getRegNubmer,
                loading,
                errors,
                handleSave,
                // handleSaveOut,
                // handleSaveIn,
                searchVehicleList,
                handleTermsAndCondition,
                setTermsAndConditions,
                SetShowTermAndCond,
                closeWarningModal
            }}
        >
            {props.children}
        </LoanVehicleContext.Provider>
    );
};
